export default import.meta.ROLLUP_FILE_URL_mDpYdgLvaGAi6rs_xhLDjw